import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/Home/HomePage';
import BondsPage from './pages/Bonds/BondsPage';
import Sidebar from './pages/Home/Sidebar';
import { AuthProvider as AuthContextProvider } from './contexts/AuthContext';
import { AuthProvider } from './components/AuthProvider';
import './styles/index.css';

export default function App() {
  return (
    <AuthContextProvider>
      <AuthProvider>
        <Router>
          <div className="app-layout">
            <Sidebar />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/obligacje" element={<BondsPage />} />
              </Routes>
            </main>
          </div>
        </Router>
      </AuthProvider>
    </AuthContextProvider>
  );
} 